import { Formik } from 'formik';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { Form } from '~/components';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import FixedDropdown from '~/components/FixedDropdown';
import { FieldProjectTaskSelect } from '~/components/ProjectTaskSelect';
import { useApi, useWorkspace } from '~/contexts';
import * as Yup from 'yup';

const Content = styled.div`
  display: grid;
  row-gap: 1.25rem;
`;

const ContentRow = styled.div`
  display: flex;
  align-items: center;
`;

const TaskName = styled.strong`
  margin: 0 0.25rem;
`;

const InlineWrapper = styled.span`
  display: inline-flex;
  vertical-align: middle;
`;

const TaskSelectContainer = styled.div`
  width: 25rem;
`;

function TimeEntryRow() {
  return 'Time Entry';
}

function MoveTimeConfirmation({ task, project, onClose, onComplete }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const formRef = useRef();

  return (
    <BulkActionModal
      title="Move Time"
      onClose={onClose}
      onComplete={onComplete}
      confirmText="Move Time"
      onConfirm={() => formRef.current?.submitForm()}
      renderRow={TimeEntryRow}>
      <Formik
        innerRef={formRef}
        initialValues={{ targetTask: null }}
        onSubmit={async (values) => {
          return api.www
            .workspaces(workspace.id)
            .projects(project.id)
            .tasks(task.id)
            .moveTime({ targetTaskId: values.targetTask.id })
            .then((r) => r.data);
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          targetTask: Yup.mixed().required().label('Task'),
        })}>
        <Form>
          <Content>
            <ContentRow>
              Move all time entries from <TaskName>{task.name}</TaskName> to another task in this project.
            </ContentRow>
            <ContentRow>
              <InlineWrapper>
                <TaskSelectContainer>
                  <FieldProjectTaskSelect
                    name="targetTask"
                    project={project}
                    placeholder="Select a task"
                    exclude={[task.id]}
                    component={FixedDropdown}
                    onFilter={(options) => options.filter((o) => o.task.mode !== 'group' && !o.task.lockTime)}
                  />
                </TaskSelectContainer>
              </InlineWrapper>
            </ContentRow>
          </Content>
        </Form>
      </Formik>
    </BulkActionModal>
  );
}

export default MoveTimeConfirmation;
